import { CustomerDetailFullAccount } from '../../../../../../store/customerDetail/types';
import { CustomerDuckInfoProps } from '../InfoContainer/components/CustomerDuckInfo';

export const getPersonalInfos = (
  customerDetail: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean
): CustomerDuckInfoProps[] => {
  return [
    {
      label: 'Nome Completo',
      value: customerDetail?.personalInformation.fullNameNormalized,
      loading: isLoading,
    },
    {
      label: 'CPF/CNPJ',
      value: customerDetail?.personalInformation.cpfCnpjNormalized,
      loading: isLoading,
    },
    {
      label: 'RG',
      value: customerDetail?.personalInformation.rgNormalized,
      loading: isLoading,
    },
    {
      label: 'Telefone',
      value: customerDetail?.personalInformation.phoneNumberNormalized,
      loading: isLoading,
      copyValue: customerDetail?.personalInformation.phone || '',
    },
    {
      label: 'E-mail',
      value: customerDetail?.personalInformation.emailNormalized,
      loading: isLoading,
      copyValue: customerDetail?.personalInformation.emailNormalized,
    },
    {
      label: 'Estado civil',
      value: customerDetail?.personalInformation.maritalStatusNormalized,
      loading: isLoading,
    },
    {
      label: 'Data de nascimento',
      value: customerDetail?.personalInformation.birthDateNormalized,
      loading: isLoading,
    },
    {
      label: 'Nacionalidade',
      value: customerDetail?.personalInformation.nationalityNormalized,
      loading: isLoading,
    },
    {
      label: 'Indicador NIF',
      value: customerDetail?.personalInformation.nifIndicatorNormalized,
      loading: isLoading,
    },
    {
      label: 'Sexo',
      value: customerDetail?.personalInformation.genderNormalized,
      loading: isLoading,
    },
    {
      label: 'Profissão',
      value: customerDetail?.personalInformation.professionNormalized,
      loading: isLoading,
    },
  ];
};

export const getInstitutionalInfos = (
  customerDetail: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean
): CustomerDuckInfoProps[] => {
  return [
    {
      label: 'Fundo Exclusivo',
      value: customerDetail?.institutionalData?.exclusiveFundNormalized,
      loading: isLoading,
    },
    {
      label: 'Empresa sem fins lucrativos',
      value: customerDetail?.institutionalData?.nonProfitCompanyNormalized,
      loading: isLoading,
    },
    {
      label: 'Trust ou veículo assemelhado',
      value: customerDetail?.institutionalData?.trustOrSimilarVehicleNormalized,
      loading: isLoading,
    },
    {
      label: 'Atividade econômica princ.',
      value: customerDetail?.institutionalData?.mainEconomicActivityNormalized,
      loading: isLoading,
    },
  ];
};

export const getAgentInfos = (
  customerDetail: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean
): CustomerDuckInfoProps[] => {
  if (!customerDetail?.representatives?.length) {
    return [
      { label: 'Possui', value: 'Não', loading: isLoading },
      { label: 'Tipo de pessoal', value: '--', loading: isLoading },
      { label: 'Nome/Razão social', value: '--', loading: isLoading },
      { label: 'CPF/CNPJ', value: '--', loading: isLoading },
    ];
  }
  return (
    customerDetail?.representatives
      ?.map((rep) => [
        {
          label: 'Possui',
          value: 'Sim',
          loading: isLoading,
        },
        {
          label: 'Tipo de pessoal',
          value: rep.representativeTypeNormalized,
          loading: isLoading,
        },
        {
          label: 'Nome/Razão social',
          value: rep.representativeNameNormalized,
          loading: isLoading,
        },
        {
          label: 'CPF/CNPJ',
          value: rep.representativeCpfCnpjNormalized,
          loading: isLoading,
        },
      ])
      .flat() || []
  );
};

export const getResidentialInfos = (
  customerDetail: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean
): CustomerDuckInfoProps[] => {
  return [
    {
      label: 'CEP',
      value: customerDetail?.residentialData.zipCodeNormalized,
      loading: isLoading,
    },
    {
      label: 'Endereço',
      value: customerDetail?.residentialData.addressNormalized,
      loading: isLoading,
    },
    {
      label: 'Logradouro',
      value: customerDetail?.residentialData.addressNumberNormalized,
      loading: isLoading,
    },
    {
      label: 'Bairro',
      value: customerDetail?.residentialData.neighborhoodNormalized,
      loading: isLoading,
    },
    {
      label: 'Cidade',
      value: customerDetail?.residentialData.cityNormalized,
      loading: isLoading,
    },
    {
      label: 'Estado',
      value: customerDetail?.residentialData.stateNormalized,
      loading: isLoading,
    },
  ];
};

export const getAdvisorInfos = (
  customerDetail: CustomerDetailFullAccount | null | undefined,
  isLoading: boolean
): CustomerDuckInfoProps[] => {
  return [
    {
      label: 'Assessor',
      value: customerDetail?.accountAndEarnings.advisorNameNormalized,
      loading: isLoading,
    },
    {
      label: 'Escritório do assessor',
      value: customerDetail?.accountAndEarnings.partnerNameNormalized,
      loading: isLoading,
    },
  ];
};
